<template>
  <div class="vx-card">
    <grid-panel
        :column-defs="columnDefs"
        height="md-plus"
        :url="() => this.$api.facilities.markets.list(id)"
        :auto-size="true"
        @rowClicked="view"
        title="Markets"
    >
      <vs-dropdown-item v-if="componentAccess.canCreate.access">
        <span
            class="flex items-center"
            @click="$router.push({ name: 'facilities.markets.create' })"
        >
          <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="mr-2" />
          <span>Create Market</span>
        </span>
      </vs-dropdown-item>

    </grid-panel>
  </div>
</template>

<script>
import GridPanel from '@/views/components/ag-grid/GridPanel';
import CellRendererDate from "@/views/components/ag-grid/cell-renderer/CellRendererDate";
import CanAccessMixin from "@/components/mixins/CanAccessMixin";
import {dateFilterParams} from '@/views/components/ag-grid/filter-params/DateComparator';

export default {
  name: 'MarketList',
  components: {
    GridPanel,
    CellRendererDate,
  },
  mixins: [CanAccessMixin],
  data() {
    return {
      componentAccess: {
        canCreate: {
          route: 'facilities.markets.create',
          access: false,
        },
      },
      columnDefs: [
        {
          headerName: 'Market #',
          field: 'id',
          minWidth: 350,
          filter: 'agTextColumnFilter',
        },
        {
          headerName: 'Name',
          field: 'MarketName',
          minWidth: 350,
          filter: 'agTextColumnFilter',
        },
        {
          headerName: 'Description',
          field: 'MarketDescription',
          minWidth: 350,
          filter: 'agTextColumnFilter',
        },
        {
          headerName: 'Total %',
          field: 'TotalPercentage',
          minWidth: 350,
          filter: 'agTextColumnFilter',
        },
        {
          headerName: 'Inception Date',
          field: 'InceptionDate',
          minWidth: 350,
          filter: 'agDateColumnFilter',
          cellRenderer: "CellRendererDate",
          filterParams: dateFilterParams,
        },
        {
          headerName: 'Expiry Date',
          field: 'ExpiryDate',
          minWidth: 350,
          filter: 'agDateColumnFilter',
          cellRenderer: "CellRendererDate",
          filterParams: dateFilterParams,
        },
      ]
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    }
  },
  methods: {
    async view({data}) {
      const route = 'facilities.markets.view';

      if (await this.canAccessRoute(route)) {
        this.$router.push({ name: route, params: { id: this.id, marketId: data.id }}).catch(() => {});
      }
    },
  },
};
</script>

<style scoped>

</style>
